<template>
  <div class="filters">
    <filter-folding
      key="starRating"
      :filter="filtersLocal.starRating"
      type="checkbox"
      :title="'Star Rating'"
      no-divider
    />
    <filter-folding
      key="priceRange"
      type="slider"
      :filter="filtersLocal.priceRange"
      title="Price Range"
      no-divider
    />
    <filter-folding
      key="propertyType"
      type="checkbox"
      :filter="filtersLocal.propertyType"
      title="Property Type"
      no-divider
    />
    <filter-folding
      key="pointOfInterest"
      :filter="filtersLocal.pointOfInterest"
      type="slider"
      title="Point of Interest"
      no-divider
    >
      <template #before>
        <form-input
          v-model="filtersLocal.pointOfInterest.inputValue"
          placeholder="Search"
          class="filter__input"
        >
          <template #icon>
            <img
              :src="require('@/assets/icons/icon-search.svg')"
              alt="Search"
            >
          </template>
        </form-input>
      </template>
    </filter-folding>
    <filter-folding
      key="amenities"
      :filter="filtersLocal.amenities"
      title="Amenities"
      no-divider
    >
      <form-autocomplete
        :items="hotelFacilitiesList"
        :selected="filtersLocal.amenities.selected"
        @add="filtersLocal.amenities.selected.push($event);"
      />
      <ul
        v-if="filtersLocal.amenities.selected.length > 0"
        class="list-autocomplete-items filter__selected"
      >
        <li
          v-for="item in filtersLocal.amenities.selected"
          :key="item.id"
          class="list-autocomplete-items__item"
        >
          <autocomplete-item
            :data="item"
            @clear="clearAmenity"
          />
        </li>
      </ul>
      <span style="text-transform: uppercase; font-size: 9px; line-height: 20px;">must have</span>
    </filter-folding>
    <filter-folding
      key="roomClass"
      type="checkbox"
      :filter="filtersLocal.roomClass"
      title="Room Class"
      no-divider
    />
    <filter-folding
      key="bedding"
      type="checkbox"
      :filter="filtersLocal.bedding"
      title="Bedding"
      no-divider
    />
    <filter-folding
      key="occupancy"
      type="select"
      :filter="filtersLocal.occupancy"
      title="Occupancy"
      no-divider
    >
      <template #after>
        <span style="text-transform: uppercase; font-size: 9px; line-height: 20px;">people in room</span>
      </template>
    </filter-folding>
    <filter-folding
      key="roomSize"
      type="slider"
      :filter="filtersLocal.roomSize"
      title="Room Size"
      no-divider
    />
    <filter-folding
      key="mealPlan"
      type="checkbox"
      :filter="filtersLocal.mealPlan"
      title="Meal Plan"
      no-divider
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  name: 'filters-sidebar',
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filtersLocal: cloneDeep(this.filters),
    };
  },
  computed: {
    ...mapState(['hotelFacilitiesList']),
  },
  methods: {
    clearAmenity(id) {
      const index = this.filtersLocal.amenities.selected.findIndex(item => id === item.id);
      if (index === -1) return;
      this.filtersLocal.amenities.selected.splice(index, 1);
    },
  },
};
</script>
